import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined'
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined'
import Chip from '@mui/material/Chip'
import React from 'react'

import T from 'T'

import { OPTIMIZATION_OUTCOME, type OptimizationOutcome } from './useOptimizationReview'

import type { ChipProps } from '@mui/material/Chip'

const OUTCOME_CHIP: Record<OptimizationOutcome, { label: string; color: ChipProps['color']; icon: React.ReactElement }> = {
  [OPTIMIZATION_OUTCOME.APPLIED]: { label: T.APPLIED, color: 'success', icon: <CheckCircleOutlineIcon /> },
  [OPTIMIZATION_OUTCOME.REJECTED]: { label: T.REJECTED, color: 'error', icon: <DoNotDisturbOnOutlinedIcon /> },
  // Warning, not default: an undecided run is the only one of the three still asking for something.
  [OPTIMIZATION_OUTCOME.PENDING]: { label: T.PENDING_REVIEW, color: 'warning', icon: <HourglassEmptyOutlinedIcon /> },
}

const OptimizationOutcomeChip = ({ outcome }: { outcome?: OptimizationOutcome }) => {
  if (!outcome) return null

  const { label, color, icon } = OUTCOME_CHIP[outcome]
  return <Chip color={color} icon={icon} label={label} size="small" variant="outlined" />
}

export default OptimizationOutcomeChip
